/* eslint-disable react/no-children-prop */
import React from "react";
import ReactMarkdown from "react-markdown";
import { BaseLayout } from "../components";
import { useCongress } from "../hooks";

const InfoPage = () => {
  const { congress } = useCongress();
  return (
    <BaseLayout>
      <ReactMarkdown children={congress.infoPageBody} />
    </BaseLayout>
  );
};

export default InfoPage;
